export function findWithIndex<T>(items: T[], predicate: (value: T, index: number, obj: T[]) => boolean): { index: number; item?: T } {
    for (let i = 0; i < items.length; i++) {
        if (predicate(items[i], i, items)) {
            return { index: i, item: { ...items[i] } };
        }
    }

    return { index: -1, item: undefined };
}
